import {z} from 'zod';

import type {Nullish} from 'shared/web';

import {
  TitleExtensionLanguage,
  TitleExtensionLanguageSchema,
} from '../titleExtensionEquipment/types';

export const TitleExtensionSuggestionUsedItemSchema = z.object({
  featureKey: z.string(),
  shortName: z.string(),
});
export type TitleExtensionSuggestionUsedItem = z.infer<
  typeof TitleExtensionSuggestionUsedItemSchema
>;

export const TitleExtensionSuggestionEmptyReasonSchema = z.enum([
  'no_list',
  'no_matching_equipment',
  'nothing_to_add',
]);
export type TitleExtensionSuggestionEmptyReason = z.infer<
  typeof TitleExtensionSuggestionEmptyReasonSchema
>;

export const TitleExtensionSuggestionResponseSchema = z.object({
  // Full input value, including unchanged text when emptyReason is set.
  text: z.string(),
  language: TitleExtensionLanguageSchema,
  // Returned for testing/diagnostics only — never rendered.
  usedItems: z.array(TitleExtensionSuggestionUsedItemSchema),
  emptyReason: TitleExtensionSuggestionEmptyReasonSchema.nullable(),
});
export type TitleExtensionSuggestionResponse = z.infer<
  typeof TitleExtensionSuggestionResponseSchema
>;

export type GetTitleExtensionSuggestionApiArg = {
  vehicleId: string;
  // Omitted for the base input, which resolves to the tenant's default content language.
  language?: TitleExtensionLanguage;
  currentValue?: string | Nullish;
};
